import { CommonModule, NgOptimizedImage } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core';
import { RouterModule } from '@angular/router';
import { AnimateModule, UserType, WwwAppState } from '@pro-connect/shared';
import { IProEducationTraining } from '../../models/pro-education-training';
import { NgxMaskPipe } from 'ngx-mask';
import { select, Store } from '@ngxs/store';
import { IProEducationEvent } from '../../models/pro-education-event';
import { ProEducationTrainingStateMarkEvent } from '../../pro-education-training.state';

@Component({
  selector: 'app-pro-edu-tra-top',
  templateUrl: './pro-edu-tra-top.component.html',
  styleUrls: ['./pro-edu-tra-top.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, RouterModule, AnimateModule, NgOptimizedImage, NgxMaskPipe],
})
export class ProEduTraTopComponent {
  public trainingDetails = input.required<IProEducationTraining | null>();
  public readonly UserType = UserType;
  public readonly user = select(WwwAppState.user);
  private readonly _store = inject(Store);

  public goToEvent(event: IProEducationEvent): void {
    const idGen = 'event' + event.id;
    const element = document.getElementById(idGen);
    if (element?.getBoundingClientRect()?.width) {
      const yOffset = -100;
      if (element) {
        const y = element.getBoundingClientRect().top + window.scrollY + yOffset;
        window.scrollTo({ top: y, behavior: 'smooth' });
      }
    } else {
      const elementSwiper = document.getElementById('eduswiper');
      if (elementSwiper) {
        const yOffset = -10;
        const y = elementSwiper.getBoundingClientRect().top + window.scrollY + yOffset;
        window.scrollTo({ top: y, behavior: 'smooth' });
      }
    }
    this._store.dispatch([new ProEducationTrainingStateMarkEvent({ event: event })]);
  }
}
